import React, { Ref, RefObject } from 'react';
import styles from './styles.module.css';
import { Blog, setState } from '@/commonTypes';
import BlogMenu from '../BlogMenu';
import BlogText from '../BlogText';
import BlogTags from '../BlogTags';

export default function BlogBody({
  data,
  tocData,
  processedContent,
  activeId,
  setActiveId,
  contentRef,
}: {
  data?: Blog;
  tocData?: any;
  processedContent?: string;
  activeId?: string;
  setActiveId?: setState<string | undefined>;
  contentRef?: RefObject<HTMLDivElement>;
}) {
  return (
    <div className={`${styles.post_body_grid} relative container`}>
      <BlogMenu tocData={tocData} activeId={activeId} setActiveId={setActiveId} />

      <BlogText processedContent={processedContent} contentRef={contentRef} data={data} />

      {/* <BlogReactions data={data} className={`${styles.reactionsDesktop}`} /> */}
    </div>
  );
}
